<script>
  import Tour from "./Tour.svelte";
  import Modal from "svelte-simple-modal";
  import { onMount } from "svelte";

  let config;

  const fetchConfig = async () => {
    while (!config) {
      try {
        const response = await fetch("./build/tour-config.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        config = await response.json();
      } catch (error) {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
        await new Promise((resolve) => setTimeout(resolve, 3000)); // Retry after 3 seconds
      }
    }
  };

  onMount(() => {
    fetchConfig();
  });
</script>

<!-- /*____________ Markup ____________*/ -->
<main>
  {#if config}
    <Modal>
      <Tour tour={config} />
    </Modal>
  {/if}
</main>

<!-- /*____________ CSS ____________*/ -->
<style>
  main {
    padding: 0;
    margin: 0;
    width: 100vw;
    height: 100vh;
  }

  :global(html, body) {
    overflow: hidden;
    width: 100%;
    height: 100%;
    margin: 0;
  }

  :global(.no-select) {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>
